import React from "react";
import { PenLine } from "lucide-react";

const Col = ({ title, nameKey, rolKey, d, set, base, color }) => (
  <div className="rounded-lg border border-nardo-200 p-2.5" data-testid={`${base}-${nameKey}-col`}>
    <div className="text-[10px] uppercase tracking-[0.15em] text-nardo-500 font-semibold mb-1.5">{title}</div>
    <input
      value={d[nameKey] || ""}
      onChange={set(nameKey)}
      data-testid={`${base}-${nameKey}`}
      placeholder="Colocar nombre"
      style={{ "--tw-ring-color": color }}
      className="w-full border border-nardo-200 rounded-md px-2 py-1.5 text-sm text-navy outline-none focus:ring-2 mb-1.5"
    />
    <input
      value={d[rolKey] ?? ""}
      onChange={set(rolKey)}
      data-testid={`${base}-${rolKey}`}
      placeholder="Rol (editable)"
      style={{ "--tw-ring-color": color }}
      className="w-full border border-nardo-100 bg-nardo-50/40 rounded-md px-2 py-1 text-[11px] text-nardo-600 outline-none focus:ring-2"
    />
  </div>
);

// Editor de las 3 firmas (Docente · Director(a) · Coordinador(a)) para todas las planeaciones.
// Requiere que el formulario padre exponga `d` (objeto data) y `set(key)` (handler onChange).
export default function FirmasEditor({ d, set, base = "firmas", color = "#112240" }) {
  return (
    <div className="p-3 rounded-lg border border-dashed border-nardo-300" data-testid={`${base}-editor`}>
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-nardo-500 font-semibold mb-2">
        <PenLine className="w-3 h-3" /> Firmas para imprimir (nombre y rol · editables)
      </div>
      <div className="grid sm:grid-cols-3 gap-2.5">
        <Col title="Docente (izquierda)" nameKey="firma_docente_name" rolKey="firma_docente_rol" d={d} set={set} base={base} color={color} />
        <Col title="Director(a) (centro)" nameKey="firma_director_name" rolKey="firma_director_rol" d={d} set={set} base={base} color={color} />
        <Col title="Coordinador(a) (derecha)" nameKey="firma_coord_name" rolKey="firma_coord_rol" d={d} set={set} base={base} color={color} />
      </div>
      <p className="text-[10px] text-nardo-400 mt-2">
        En el PDF aparece la línea para firmar, debajo el nombre que escribas y luego el rol. Si dejas el nombre vacío, se imprime “Colocar nombre”.
      </p>
    </div>
  );
}
